import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Scroller() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 250);
  }, [pathname]);

  return null;
}

export default Scroller;
